export function getFileTooltipText(node) {
    return node.glName ? "Name: " + node.name + "\nGLName: " + node.glName : "";
}
